module.exports = __webpack_public_path__ + "img/Group 9740.a26acc37.svg";